// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"ec12a6be","453":"6c0734eb"}[chunkId] + ".chunk.js";
};